import { __assign } from "tslib";
export var createWorkflowsApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl, "/recipes");
    var scenarioUrl = function (scenarioId) { return "".concat(baseUrl, "/recipes/").concat(scenarioId); };
    var recipeUrl = function (recipeType) { return "".concat(baseUrl, "/recipes/notification/").concat(recipeType, "/preview"); };
    return {
        getAll: function () {
            return http.get(apiUrl);
        },
        get: function (recipeId) {
            return http.get(scenarioUrl(recipeId));
        },
        addScenario: function (dto) {
            return http.post(apiUrl, __assign(__assign({}, dto), { disabled: false }));
        },
        deleteScenario: function (scenarioId) {
            return http.delete(scenarioUrl(scenarioId));
        },
        updateScenario: function (scenario) {
            return http.put(scenarioUrl(scenario.id), scenario);
        },
        enableScenario: function (scenarioId) {
            return http.put("".concat(scenarioUrl(scenarioId), "/enable"), {});
        },
        disableScenario: function (scenarioId) {
            return http.put("".concat(scenarioUrl(scenarioId), "/disable"), {});
        },
        getEmailTemplatePreview: function (_a) {
            var recipeType = _a.recipeType, locale = _a.locale;
            return http.post("".concat(recipeUrl(recipeType)), { recipeType: recipeType, locale: locale });
        }
    };
};
//# sourceMappingURL=index.js.map